import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { fmtErr } from "@/lib/api";
import { MonitorSmartphone } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/", { replace: true });
  }, [user, navigate]);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const u = await login(email, password);
      navigate(u.must_change_password ? "/passwort-aendern" : "/");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-sm border border-cyan-500/40 bg-cyan-500/10 mb-4">
            <MonitorSmartphone className="text-cyan-400" size={22} strokeWidth={1.5} />
          </div>
          <div className="font-display text-2xl font-extrabold tracking-tight text-slate-100">
            REX<span className="text-cyan-400">//</span>SIGNAGE
          </div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-slate-400 mt-2">
            Cloud Control Plane · Anmeldung
          </div>
        </div>

        <form onSubmit={submit} className="panel p-6 space-y-4" data-testid="login-form">
          <div>
            <label className="mono-label block mb-1.5" htmlFor="login-email">E-Mail</label>
            <input
              id="login-email"
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-dark"
              placeholder="name@firma.de"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="mono-label block mb-1.5" htmlFor="login-password">Passwort</label>
            <input
              id="login-password"
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-dark"
              placeholder="••••••••"
              data-testid="login-password-input"
            />
          </div>
          {error ? (
            <div className="border border-red-500/40 bg-red-500/10 text-red-300 text-xs font-mono px-3 py-2 rounded-sm" data-testid="login-error">
              {error}
            </div>
          ) : null}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit-button">
            {busy ? "Prüfe…" : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
}
